/* eslint-disable no-param-reassign */
import * as pageActions from "../../actions/pageActions";
import * as windowSize from "../../lib/windowSize";
import axios from "axios";
import logout from "../logout";
import store from "../store";

const ONE_SEC_IN_MS = 1000;
let onBeforeUnload;

function resetOnBeforeUnload() {
	window.onbeforeunload = onBeforeUnload;
}

function downloadReportWithId(id, i) {
	const url = `${__API_ROOT__}/documents/report/${id}`;
	const link = document.createElement("a");
	link.href = url;
	link.download = id;
	document.body.appendChild(link);
	setTimeout(() => {
		onBeforeUnload = window.onbeforeunload;
		// NOTE(CK): onbeforeunload does not fire in this scenario in Safari, so if/once a report is
		// downloaded in Safari, the beforeOnload confirmation on a dirty binder page will not pop up
		window.onbeforeunload = resetOnBeforeUnload;
		link.click();
		window.URL.revokeObjectURL(url);
		document.body.removeChild(link);
	}, ONE_SEC_IN_MS * i);
}

function checkMaintenance(headers) {
	const maintenanceTime = headers["x-docketnavigator-maintenance-epoch"] || null;
	const maintenanceTimeAsNum = maintenanceTime ? parseInt(maintenanceTime, 10) : null;
	const scheduledMaintenance = store.getState().page.scheduledMaintenance;
	if (maintenanceTimeAsNum !== scheduledMaintenance) {
		store.dispatch(pageActions.pageSetScheduledMaintenance(maintenanceTimeAsNum));
	}
}

function checkDownloadHeader(headers) {
	const downloads = headers["x-docketnavigator-downloads"] || null;
	if (!downloads) {
		return;
	}

	const downloadArr = downloads.split(", ");
	if (!downloadArr.length) {
		return;
	}

	downloadArr.forEach(downloadReportWithId);
}

export function responseInterceptorSuccess(response) {
	checkMaintenance(response.headers);
	if (!windowSize.isMobile()) {
		checkDownloadHeader(response.headers);
	}
	const serverRevision = response.headers["x-docketnavigator-client-revision"];
	if (
		!__DEV__ &&
		serverRevision &&
		serverRevision !== __VERSION__ &&
		!store.getState().page.clientOutdated
	) {
		store.dispatch(pageActions.pageSetClientOutdated(true));
	}

	return response;
}

function responseInterceptorError(err) {
	err.handled = false;

	if (err.response && err.response.status === 401) {
		err.handled = true;

		if (store.getState().page.clientUnauthorized) {
			return Promise.reject(err);
		}

		store.dispatch(pageActions.pageSetClientUnauthorized(true));
		return logout(false, true).finally(() => {
			store.dispatch(pageActions.pageSetClientUnauthorized(false));
			return Promise.reject(err);
		});
	}

	if (
		err.response &&
		err.response.status === 400 &&
		err.response.data &&
		typeof err.response.data === "object"
	) {
		err.validation = err.response.data;
		return Promise.reject(err);
	}

	if (err.response && err.response.status === 500) {
		const serviceUnavailable = store.getState().page.serviceUnavailable;
		if (!serviceUnavailable) {
			store.dispatch(pageActions.pageSetServiceUnavailable(true));
		}
		err.handled = true;
		return Promise.reject(err);
	}

	return Promise.reject(err);
}

const config = {
	baseURL: __API_ROOT__,
	withCredentials: __CORS__,
	headers: {},
};

if (__CORS__) {
	config.headers["X-Requested-With"] = "something-cryptic";
}

const instance = axios.create(config);
instance.interceptors.response.use(responseInterceptorSuccess, responseInterceptorError);
export default instance;
